import React, { Fragment } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Fade from 'react-reveal/Fade';
import Text from 'common/src/components/Text';
import Heading from 'common/src/components/Heading';
import Button from 'common/src/components/Button';
import Box from 'common/src/components/Box';
import Image from 'common/src/components/Image';
import Container from 'common/src/components/UI/Container';
import Rating from 'common/src/components/Rating';
import GlideCarousel from 'common/src/components/GlideCarousel';
import GlideSlide from 'common/src/components/GlideCarousel/glideSlide';
import { SectionHeader } from '../appClassic.style';
import PropTypes from 'prop-types';
import SectionWrapper, { BoxWrapper } from './tech.style';
import nodeLogo from 'common/src/assets/image/appClassic/nodejs.svg';
import reactNativeLogo from 'common/src/assets/image/appClassic/react-native.svg';
import reactLogo from 'common/src/assets/image/appClassic/react.svg';
import storybookLogo from 'common/src/assets/image/appClassic/storybook.svg';
import reduxLogo from 'common/src/assets/image/appClassic/redux.svg';

const Technology = ({ imageSrc, text }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "120px", marginBottom: "20x", marginLeft: "30px" }}>
      <div style={{ width: "120px", height: "140px" }}>
        <Image style={{ width: "120px", height: "120px" }} src={imageSrc} />
      </div>
      <div style={{ fontSize: "20px", textAlign: "center" }}>
        {text}
      </div>
    </div>
  )
}

const Tech = ({ sectionTitle, sectionSubTitle }) => {

  return (
    <SectionWrapper id="tech">
      <Container>
        <SectionHeader>
          <Fade up>
            <Text content={"TECH"} {...sectionSubTitle} />
            <Heading content={"Our core technology stack"} {...sectionTitle} />
            <Text className="subtitle" content={`Focused on building JavaScript apps using React.js, React Native and Node.js at an highly productive and cost efficient way!. By keeping 100% JavaScript ecosystem we maintain a high degree of code sharability between different interfaces of your app.`} />
          </Fade>
        </SectionHeader>
        <BoxWrapper>
          <Technology imageSrc={reactLogo} text={"React"} />
          <Technology imageSrc={reactNativeLogo} text={"React Native"} />
          <Technology imageSrc={nodeLogo} text={"Node.js"} />
          <Technology imageSrc={reduxLogo} text={"Redux"} />
          <Technology imageSrc={storybookLogo} text={"Storybook"} />
        </BoxWrapper>
      </Container>
    </SectionWrapper >
  );
};

Tech.propTypes = {
  sectionTitle: PropTypes.object,
  sectionSubTitle: PropTypes.object,
};

Tech.defaultProps = {
  sectionSubTitle: {
    as: 'span',
    display: 'block',
    textAlign: 'center',
    fontSize: '14px',
    letterSpacing: '0.15em',
    fontWeight: '700',
    color: '#0D5EAF',
    mb: '10px',
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: "24px!important",
    fontWeight: '400!important',
    color: '#0f2137!important',
    letterSpacing: '-0.025em!important',
    mb: '0',
  }
};

export default Tech;
